export default "__VITE_ASSET__bAADFw0u__"